import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const OpenCheckImageIcon: FC<ISvgProps> = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="39"
			height="45"
			viewBox="0 0 39 45"
			fill="none"
			style={{ outline: 'none', border: 'none' }}>
			<g filter="url(#filter0_dd_440_41420)">
				<circle cx="19.2965" cy="18.9752" r="12.651" fill="white" />
			</g>
			<path
				d="M24.3961 22.9745L27.7302 26.3079L26.6287 27.4094L23.2953 24.0753C22.055 25.0695 20.5123 25.6103 18.9227 25.6081C15.0553 25.6081 11.9165 22.4693 11.9165 18.6019C11.9165 14.7345 15.0553 11.5957 18.9227 11.5957C22.7901 11.5957 25.9289 14.7345 25.9289 18.6019C25.9311 20.1915 25.3903 21.7342 24.3961 22.9745ZM22.8345 22.3969C23.8224 21.3809 24.3742 20.019 24.3719 18.6019C24.3719 15.5908 21.933 13.1526 18.9227 13.1526C15.9116 13.1526 13.4734 15.5908 13.4734 18.6019C13.4734 21.6122 15.9116 24.0511 18.9227 24.0511C20.3398 24.0534 21.7017 23.5016 22.7177 22.5137L22.8345 22.3969ZM18.1442 17.8234V15.488H19.7011V17.8234H22.0365V19.3803H19.7011V21.7157H18.1442V19.3803H15.8088V17.8234H18.1442Z"
				fill="#5770F6"
			/>
			<defs>
				<filter
					id="filter0_dd_440_41420"
					x="0.320018"
					y="-0.00127077"
					width="37.9527"
					height="44.2782"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="6.32549" />
					<feGaussianBlur stdDeviation="3.16274" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.1 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_440_41420" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3.16274" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.12 0"
					/>
					<feBlend mode="normal" in2="effect1_dropShadow_440_41420" result="effect2_dropShadow_440_41420" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_440_41420" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
